 <svg
    class="x-icon"
    style="transform: scale(1.1)"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height="100%"
    width="100%"
    fill="currentColor"

  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <rect
      class="x-icon__top"
      x="12.5%"
      y="25%"
      width="75%"
      height="8.25%"
    ></rect>

    <rect
      class="x-icon__middle"
      x="12.5%"
      y="45.875%"
      width="75%"
      height="8.25%"
    ></rect>

    <rect
      class="x-icon__bottom"
      x="12.5%"
      y="66.666%"
      width="75%"
      height="8.25%"
    ></rect>
  </svg>
